import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Col, ControlLabel, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { getOrgTermsContent } from '../../content/utils.js';
import DatePickerAdapter from '../DatePickerAdapter.jsx';
import FieldGroup from '../FieldGroup.jsx';
import { FormError } from '../FormError.jsx';
import RadioOptionsField from '../RadioOptionsField.jsx';
import MultiSelect from '../MultiSelect.jsx';
import { ProjectsLink } from '../links/index.jsx';

const ParentPortfolioForm = (props) => {
  const {
    values,
    submitError,
    submitFailed,
    submitting,
    handleSubmit,
    projectStatuses,
    portfolios,
    selectedPortfolios,
    updateSelectedPortfolios,
  } = props;

  const [projectStatusesActive, setProjectStatusesActive] = useState([]);

  useEffect(() => {
    if (projectStatuses) {
      setProjectStatusesActive(
        projectStatuses
          .map((s) => ({
            ...s,
            label: s.archived ? `${s.name} (archived)` : s.name,
            value: `${s.id}`,
          }))
          .filter(
            (item) =>
              !item.archived ||
              (values &&
                item.archived &&
                `${item.id}` === `${values.projectStatusId}`)
          )
      );
    }
  }, [values.projectStatusId, projectStatuses]);

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs={8}>
          <Field
            id="name"
            name="name"
            label="Title"
            placeholder={getOrgTermsContent('parentPortfolioLabels.title')}
            type="text"
            component={FieldGroup}
          />
        </Col>
      </Row>

      <Row>
        <Col sm={8}>
          <Row>
            <Col sm={6}>
              <Field
                id="formStartDate"
                name="start_date"
                label="Start Date"
                placeholderText="Select a date"
                component={DatePickerAdapter}
                allowNull
              />
            </Col>
            <Col sm={6}>
              <Field
                id="formEndDate"
                name="end_date"
                label="End Date"
                placeholderText="Select a date"
                component={DatePickerAdapter}
                allowNull
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col xs={8}>
          <ControlLabel>Select {getOrgTermsContent('portfolio')}</ControlLabel>
          <MultiSelect
            multiple={true}
            options={portfolios || []}
            selectedOptions={selectedPortfolios}
            updateSelectedOptions={(val) => updateSelectedPortfolios(val)}
            placeholder={`Select Child ${getOrgTermsContent('portfolio')}`}
            subject={getOrgTermsContent('portfolio')}
            nameKey="name"
            additionalFields={{}}
            error={null}
          />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
          <RadioOptionsField
            id="project_status_id"
            label="Status"
            name="project_status_id"
            options={projectStatusesActive}
          />
        </Col>
      </Row>

      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
        <Col xs={12}>
          <div className="flex">
            <div>
              <ProjectsLink>
                <Button bsStyle="default">Cancel</Button>
              </ProjectsLink>
              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={submitting}
                type="submit"
              >
                {submitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
};

ParentPortfolioForm.propTypes = {
  editing: PropTypes.bool.isRequired,
};

export default ParentPortfolioForm;
